<template>
  <div class="installatorilist">
    <b-container fluid>
      <b-row class="headerbox">
        <b-col>
          <h5>Lista Installatori</h5>
        </b-col>
      </b-row>
      <br>
      <b-row>
        <b-col md="5">
          <b-form-group label-cols-sm="2" label="Cerca">
            <b-input-group>
              <b-form-input v-model="filter" placeholder="Cerca" />
              <b-input-group-append>
                <b-button :disabled="!filter" @click="filter = ''"><font-awesome-icon icon="times-circle" /></b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col>
          <b-button :disabled="licenza.num_liberi <= 0" variant="success" style="float: right" to="/installatori/aggiungi"><font-awesome-icon icon="plus-circle" /> Aggiungi Installatore</b-button>
        </b-col>
      </b-row>
      <br>
      <b-row>
        <b-col>
          <b-table
            :striped="true"
            :hover="true"
            :responsive="true"
            :items="lista"
            :fields="campi"
            :current-page="currentPage"
            :per-page="perPage"
            :filter="filter"
            @filtered="onFiltered"
          >
            <template slot="action" slot-scope="row">
              <b-button size="sm" variant="danger" v-on:click="openModalDeleteInstallatore(row.item)"><font-awesome-icon icon="trash-alt" /></b-button>
              <b-button size="sm" style="margin-left: 10px;" :to="'installatori/modifica/'+row.item.id"><font-awesome-icon icon="edit" /></b-button>
              <b-button v-if="licenza.num_liberi >= 0" size="sm" style="margin-left: 10px;" variant="success" v-on:click="openModalImpersonaInstallatore(row.item)"><font-awesome-icon icon="play" /></b-button>
            </template>
          </b-table>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-pagination
            :total-rows="totalRows"
            :per-page="perPage"
            v-model="currentPage"
            align="center"
          />
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <br>
          <p style="color: grey" v-if="licenza.num_liberi >= 0">Licenza valida dal {{licenza.da}} al {{licenza.a}} per {{licenza.num_installatori}} installator{{licenza.num_installatori == 1 ? 'e' : 'i'}}. Puoi creare ancora {{licenza.num_liberi}} installator{{licenza.num_liberi == 1 ? 'e' : 'i'}}</p>
          <p style="color: grey" v-else>Non si possiede una licenza valida</p>
        </b-col>
      </b-row>
    </b-container>

    <b-modal v-model="modal.delete" title="Conferma richiesta di eliminazione!">
      <p>Sei sicuro di voler eliminare: <br>-> <strong>{{modalData.delete.denominazione}} - {{modalData.delete.piva}}</strong>?</p>
      <div slot="modal-footer">
        <b-button class="float-right" variant="danger" style="margin-left: 10px" v-on:click="deleteInstallatore(modalData.delete.id)">Si</b-button>
        <b-button class="float-right" v-on:click="modal.delete = false">No</b-button>
      </div>
    </b-modal>

    <b-modal v-model="modal.impersona" title="Vuoi proseguire?">
      <p>Si vuole iniziare a lavorare con: <br>-> <strong>{{modalData.impersona.denominazione}} - {{modalData.impersona.piva}}</strong>?</p>
      <div slot="modal-footer">
        <b-button class="float-right" variant="success" style="margin-left: 10px" v-on:click="impersonaInstallatore(modalData.impersona.id)">Si</b-button>
        <b-button class="float-right" v-on:click="modal.impersona = false">No</b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import Vue from 'vue'
import { mapMutations, mapActions } from 'vuex'

export default {
  name: 'installatoriadd',
  data() {
    return {
      lista: [],
      campi: [
        {key: 'codice', label: 'Codice', sortable: true},
        {key: 'denominazione', label: 'Denominazione', sortable: true},
        {key: 'piva', label: 'P. IVA', sortable: true},
        {key: 'cf', label: 'Cod. Fiscale', sortable: true},
        {key: 'residenza', label: 'Residenza', sortable: true},
        {key: 'action', label: '', sortable: false}
      ],
      totalRows: 0,
      currentPage: 1,
      perPage: 10,
      filter: null,
      modal: {
        delete: false,
        impersona: false
      },
      modalData: {
        delete: {},
        impersona: {}
      },
      licenza: {}
    }
  },
  created: function(){
    this.getListaInstallatori()
  },
  methods: {
    ...mapMutations(['impersona']),
    ...mapActions(['updateUserStatus']),

    getListaInstallatori(){
      Vue.http.post('installatore/list', {}, {credentials : true}).then(response => {
        if(response.body.success){
            this.lista = response.body.data
            this.totalRows = this.lista.length
            this.licenza = response.body.licenza
        }else{
          this.lista = []
            /*Vue.notify({
                group: 'global',
                title: 'Errore',
                text: "Lista installatori non caricata correttamente.",
                type: 'error'
            })*/
        }
      }, response => {})
    },
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    openModalDeleteInstallatore(item){
      this.modalData.delete = item
      this.modal.delete = true
    },
    openModalImpersonaInstallatore(item){
      console.log(item)
      this.modalData.impersona = item
      this.modal.impersona = true
    },
    deleteInstallatore(id){
      Vue.http.post('installatore/delete/'+id, {}, {credentials : true}).then(response => {
        if(response.body.success){
          this.getListaInstallatori()
          
          this.modal.delete = false
          this.modalData.delete = {}

          Vue.notify({
              group: 'global',
              title: 'Operazione eseguita!',
              text: "Installatore eliminato correttamente.",
              type: 'success'
          })
        }else{
          Vue.notify({
              group: 'global',
              title: 'Errore',
              text: response.body.msg,
              type: 'error'
          })
        }
      }, response => {})
    },
    impersonaInstallatore(id){
      Vue.http.post('installatore/impersona/'+id, {}, {credentials : true}).then(async response => {
        if(response.body.success){
          this.impersona({stato: true, denominazione: this.modalData.impersona.denominazione+" - "+this.modalData.impersona.piva})
          await this.updateUserStatus()
          localStorage.removeItem("todo_list")
          this.$router.push('/')

          Vue.notify({
              group: 'global',
              title: 'Operazione eseguita!',
              text: "Si sta utilizzando l'installatore "+this.modalData.impersona.denominazione,
              type: 'success'
          })

          this.modal.impersona = false
          this.modalData.impersona = {}
        }else{
          Vue.notify({
              group: 'global',
              title: 'Errore',
              text: response.body.msg,
              type: 'error'
          })
        }
      }, response => {})
    }
  }
}
</script>


<style>
</style>